module.exports = __webpack_public_path__ + "img/version.b4797047.png";